import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { OnInit, Injector, Directive } from '@angular/core';
import { ServiceBase } from '@shared/services/service-base';
import { FuncBaseDirective } from '@shared/base/func-base/func-base';
import {AuthService} from "@shared/services";

@Directive()
export abstract class EditorComponentBaseDirective<T>
  extends FuncBaseDirective
  implements OnInit
{
  public data: T;
  public isEditing: boolean;
  protected userLongName;

  public formGroup: FormGroup;
  fromBuilder = new FormBuilder();

  public isLoaded = false;

  public title: string;
  constructor(
    public service: ServiceBase<T>,
    public dialogRef: MatDialogRef<EditorComponentBaseDirective<T>>,
    public id: string,
    injector: Injector,
    private getCreateEntityFromServer: boolean = false
  ) {
    super(injector);

    this.isEditing = id !== '0';
    this.title = this.isEditing ? 'edit' : 'create';

    dialogRef.disableClose = true;

    const authService = this.injector.get(AuthService);
    this.userLongName = authService.userLongName;
  }

  loadData() {
    const param = {
      id: this.id,
    };

    this.service
      .get(param)
      .subscribe({
        next: (r) => {
          this.data = r[0];
          this.formGroup = this.createFormGroupWithBuilderAndModel(r[0]);
        },
        error: (err) => {
          this.responseHandler(err, null);
        }
      });
  }

  cancel() {
    this.dialogRef.close(false);
  }

  abstract createFormGroupWithBuilderAndModel(data: T): FormGroup;
  abstract readForm(): T;


  ngOnInit() {
    this.loadData();
  }

  onSubmit() {
    // Make sure to create a deep copy of the form-model
    const result: T = this.readForm();
    // Do useful stuff with the gathered data
    if (!this.formGroup.errors) {
      let operation = !this.isEditing ? this.service.create(result) : this.service.update(this.id, result);

      operation.subscribe({
        next: (r) => {
          this.responseHandler(r, result)
        },
        error: (err) => {
          this.responseHandler(err, result)
        }
      });
    }
  }

  responseHandler(r, result) {
    if (r.status >= 200 && r.status < 300) {
      this.snackBar.showDurationSnackbar(r);
      this.dialogRef.close({ success: true, result });
    }
    else if (r.status >= 400 && r.status < 500) {
      this.snackBar.showButtonSnackbar(r);
    }
    else {
      this.dialogRef.close(true);
    }
  }
}
